import React, { useState } from 'react';
import { theme } from '../../config/theme';
import { getImageUrl } from '../../utils/productHelpers';

const ImageGallery = ({ images = [], altText = 'Product image' }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const displayImages = images ? images.map(img => getImageUrl(img)) : [];

  if (displayImages.length === 0) {
    return (
      <div style={{
        width: '100%',
        height: '400px',
        backgroundColor: theme.colors.gray[100],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.borderRadius.lg,
        color: theme.colors.text.secondary,
      }}>
        No images available
      </div>
    );
  }

  const mainImageStyles = {
    width: '100%',
    height: '400px',
    objectFit: 'contain',
    borderRadius: theme.borderRadius.lg,
    backgroundColor: theme.colors.gray[50],
    border: `1px solid ${theme.colors.gray[200]}`,
  };

  const thumbnailContainerStyles = {
    display: 'flex',
    gap: theme.spacing.sm,
    marginTop: theme.spacing.md,
    overflowX: 'auto',
  };

  const thumbnailStyles = (isSelected) => ({
    width: '80px',
    height: '80px',
    objectFit: 'cover',
    borderRadius: theme.borderRadius.md,
    cursor: 'pointer',
    border: `2px solid ${isSelected ? theme.colors.primary.main : theme.colors.gray[200]}`,
    transition: theme.transitions.base,
    flexShrink: 0,
  });

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <img 
          src={displayImages[selectedIndex]} 
          alt={`${altText} ${selectedIndex + 1}`}
          style={mainImageStyles}
        />
        
        {displayImages.length > 1 && (
          <>
            <button
              onClick={() => setSelectedIndex(prev => prev === 0 ? displayImages.length - 1 : prev - 1)}
              style={{
                position: 'absolute',
                left: theme.spacing.md,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: 'none',
                borderRadius: theme.borderRadius.full,
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: theme.shadows.md,
              }}
            >
              ←
            </button>
            <button
              onClick={() => setSelectedIndex(prev => prev === displayImages.length - 1 ? 0 : prev + 1)}
              style={{
                position: 'absolute',
                right: theme.spacing.md,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: 'none',
                borderRadius: theme.borderRadius.full,
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: theme.shadows.md,
              }}
            >
              →
            </button>
          </>
        )}
      </div>

      {displayImages.length > 1 && (
        <div style={thumbnailContainerStyles}>
          {displayImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${altText} thumbnail ${index + 1}`}
              style={thumbnailStyles(index === selectedIndex)}
              onClick={() => setSelectedIndex(index)}
              onMouseEnter={(e) => {
                if (index !== selectedIndex) {
                  e.target.style.opacity = '0.7';
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = '1';
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGallery;